/* Biomaser MTS optional motion enhancement. Content and navigation work without it. */
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const motionAllowed = !reducedMotion.matches;
  if (motionAllowed) document.documentElement.classList.add('mts-motion-ready');

  const intro = document.querySelector('[data-mts-brand-opening]');
  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let priorFocus = null;

  const activateIntro = () => {
    if (!intro || intro.hidden) return;
    priorFocus = document.activeElement;
    document.documentElement.classList.add('mts-opening-active');
    document.body.classList.add('mts-opening-active');
    window.setTimeout(() => {
      const firstFocusable = intro.querySelector(focusableSelector);
      (firstFocusable || intro).focus({ preventScroll: true });
    }, 0);
  };
  const dismiss = () => {
    if (!intro || intro.hidden) return;
    intro.hidden = true;
    document.documentElement.classList.remove('mts-opening-active');
    document.body.classList.remove('mts-opening-active');
    try { window.sessionStorage.setItem('mts-brand-opening-seen', '1'); } catch (_) { /* Storage is optional. */ }
    if (priorFocus && typeof priorFocus.focus === 'function') priorFocus.focus({ preventScroll: true });
  };

  if (intro) {
    activateIntro();
    const button = intro.querySelector('[data-mts-dismiss-intro]');
    if (button) button.addEventListener('click', dismiss);
    intro.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { event.preventDefault(); dismiss(); return; }
      if (event.key !== 'Tab') return;
      const focusable = [...intro.querySelectorAll(focusableSelector)].filter((element) => !element.hidden && element.offsetParent !== null);
      if (!focusable.length) { event.preventDefault(); intro.focus(); return; }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    let alreadySeen = false;
    try { alreadySeen = window.sessionStorage.getItem('mts-brand-opening-seen') === '1'; } catch (_) { /* Ignore unavailable storage. */ }
    const isInteractive = intro.dataset.mtsOpeningInteractive === 'true';
    const dismissInteractive = intro.dataset.mtsAutoDismissWithSignup === 'true';
    const delay = Number(intro.dataset.dismissAfter || 0);
    if (alreadySeen) dismiss();
    else if (delay > 0 && (!isInteractive || dismissInteractive)) window.setTimeout(dismiss, delay);
  }

  if (motionAllowed && !('IntersectionObserver' in window)) {
    document.querySelectorAll('.mts-reveal').forEach((element) => element.classList.add('is-visible'));
  } else if (motionAllowed && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('.mts-reveal').forEach((element) => observer.observe(element));
  }

  // Hub filtering is functional behavior, not a motion enhancement.
  // It must run even where IntersectionObserver is unavailable.
  const applyKnowledgeHubFilter = () => {
    const controlledCategories = new Set([
      'category-basics', 'category-evidence', 'category-concerns',
      'category-safety', 'category-devices', 'category-regulation'
    ]);
    const selectedCategory = new URLSearchParams(window.location.search).get('category');
    if (!controlledCategories.has(selectedCategory)) return;

    document.querySelectorAll('[data-mts-category-link]').forEach((link) => {
      const active = link.dataset.mtsCategory === selectedCategory;
      if (active) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });

    const cards = [...document.querySelectorAll('[data-mts-article-card]')];
    let visibleCount = 0;
    cards.forEach((card) => {
      const categories = (card.dataset.mtsCategories || '').split('|').filter(Boolean);
      const visible = categories.includes(selectedCategory);
      card.hidden = !visible;
      if (visible) visibleCount += 1;
    });
    document.querySelectorAll('[data-mts-category-empty]').forEach((empty) => {
      empty.hidden = visibleCount > 0;
    });
  };

  applyKnowledgeHubFilter();
})();
